import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { API_URL } from "Store/Shared/Middleware/API/Constants";
import { BUSINESS, CREATE_BUSINESS, FETCH_ALL_BUSINESSES, FETCH_BUSINESS, FETCH_BUSINESS_DATASET, SAVE_BUSINESS, SAVE_BUSINESS_STATUS } from "./ActionTypes";

export function createBusiness(value: any) {
    return {
        types: [
            CREATE_BUSINESS.REQUEST,
            CREATE_BUSINESS.SUCCESS,
            CREATE_BUSINESS.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol toegevoegd',
            [NOTIFICATIONTYPE.ERROR]: 'Toevoegen mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/businesses`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(value)
            })
    }
}

export function fetchAllBusinesses(page, searchFilter, overviewFilter) {
    let urlParams = '';
    if (searchFilter) {
        urlParams += `&searchFilter=${searchFilter}`
    }

    Object.keys(overviewFilter)?.map((i) => {
        urlParams += `&${encodeURIComponent(i)}=${overviewFilter[i]}`;
    });
    
    return {
        types: [
            FETCH_ALL_BUSINESSES.REQUEST,
            FETCH_ALL_BUSINESSES.SUCCESS,
            FETCH_ALL_BUSINESSES.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/overview?entity=business&page=${page}${urlParams}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function fetchBusiness(id: string) {
    return {
        types: [
            FETCH_BUSINESS.REQUEST,
            FETCH_BUSINESS.SUCCESS,
            FETCH_BUSINESS.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/businesses/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function saveBusiness(candidateId: any, data: any) {
    return {
        types: [
            SAVE_BUSINESS.REQUEST,
            SAVE_BUSINESS.SUCCESS,
            SAVE_BUSINESS.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol opgeslagen',
            [NOTIFICATIONTYPE.ERROR]: 'Opslaan mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/businesses/${candidateId}`,
            {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(data)
            })
    }
}

export function saveBusinessStatus(candidateId: any, data: any) {
    return {
        types: [
            SAVE_BUSINESS_STATUS.REQUEST,
            SAVE_BUSINESS_STATUS.SUCCESS,
            SAVE_BUSINESS_STATUS.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol opgeslagen',
            [NOTIFICATIONTYPE.ERROR]: 'Opslaan mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/businesses/${candidateId}`,
            {
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(data)
            })
    }
}

export function editBusiness(candidateId: any, fieldId: any, valueId: any, value: any) {
    return {
        type: BUSINESS.EDIT,
        payload: {
            candidateId: candidateId,
            fieldId: fieldId,
            valueId: valueId,
            value: value
        }
    }
}

export function resetBusiness(candidateId: any, fieldIds: any) {
    return {
        type: BUSINESS.RESET,
        payload: {
            candidateId: candidateId,
            fieldIds: fieldIds
        }
    }
}

export function fetchBusinessDataset() {
    return {
        types: [
            FETCH_BUSINESS_DATASET.REQUEST,
            FETCH_BUSINESS_DATASET.SUCCESS,
            FETCH_BUSINESS_DATASET.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/businesses/dataset`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}